// @flow
import ShakaDebugVideoStreamer from '../components/player/VideoStreamer/ShakaVideoStreamer/ShakaDebugVideoStreamer';
export default ShakaDebugVideoStreamer;
